import {showMore} from "./module/showmore";

//topics tab
//---------------------------------------------------------
function topicsTab() {
	const tabGroup = '.js-tab-group';
	const $tab =  $('.js-tab');
	const is_current = 'is-current'
	const innerTab =  '.js-inner-tab[role="tab"]';
	const innerPanel = '.js-inner-tabPanel[role="tabpanel"]';

	$tab.on('click', function (){
		let id = $(this).attr('aria-controls');
		$(this).parents(tabGroup).find('.js-inner-tab, .js-inner-tabPanel').removeClass(is_current);
		$(this).parents(tabGroup).find(innerPanel).attr('aria-hidden', true);
		$(this).parents(tabGroup).find(innerPanel).attr('aria-hidden', true);
		$(this).parents(tabGroup).find('#' + id).find(innerTab).attr('aria-selected', true);
		$(this).parents(tabGroup).find('#' + id).find(innerTab).addClass(is_current);
		$(this).parents(tabGroup).find('#' + id).find(innerPanel).attr('aria-hidden', false);
		$(this).parents(tabGroup).find('#' + id).find(innerPanel).addClass(is_current);

		if($('.js-recruit-tab').length) {
			if($('.js-recruit-tabPanel').attr({'aria-hidden':'true'})) {
				$('.js-recruit-tab, .js-recruit-tabPanel').removeClass(is_current);
				$('.js-recruit-tab[aria-selected="true"]').attr({'aria-selected':false});
				$('.js-recruit-tabPanel[aria-hidden="false"]').attr({'aria-hidden':true});
				$(this).parents(tabGroup).find('#' + id).find('ul > li:nth-child(1) .js-recruit-tab').addClass(is_current);
				$(this).parents(tabGroup).find('#' + id).find('ul > li:nth-child(1) .js-recruit-tab').attr({'aria-selected':true});
				$(this).parents(tabGroup).find('#' + id).find('.js-recruit-tabPanel:nth-child(1)').addClass(is_current);
				$(this).parents(tabGroup).find('#' + id).find('.js-recruit-tabPanel:nth-child(1)').attr({'aria-hidden':false});
			}
		}
	});
}

//recruit tab
//---------------------------------------------------------
function recruitTab() {
	const $recruitTab =  $('.js-recruit-tab');
	const innerTab =  '.js-recruit-tab[role="tab"]';
	const recruitPanel =  '.js-recruit-tabPanel[role="tabpanel"]';
	const tabGroup = '.js-tab-group';
	const is_current = 'is-current'

	$recruitTab.on('click',function(){
		let select = $(this).attr('aria-selected');
		let id = $(this).attr('aria-controls');

		if (select === 'true') {
			return false;
		}

		$(this).parents(tabGroup).find('.js-recruit-tab, .js-recruit-tabPanel').removeClass(is_current);
		$(this).parents(tabGroup).find(recruitPanel).attr('aria-hidden', true);
		$(this).parents(tabGroup).find(recruitPanel).attr('aria-hidden', true);
		$(this).parents(tabGroup).find('#' + id).attr('aria-hidden', false);
		$(this).parents(tabGroup).find('#' + id).addClass(is_current);
		$(this).parents(tabGroup).find(innerTab).attr('aria-selected', false);
		$(this).addClass(is_current);
		$(this).attr('aria-selected', true);
	});
}

//init
//---------------------------------------------------------
$(function(){
	showMore('.js-sale-show-contents', 6);
	showMore('.js-show-contents', 7);
	topicsTab();
	recruitTab();
})
